<template>
  <div 
    :class="[{'focused' : inputFocus}, {'full-width' : fullWidth}]"
    class="sleek-filter-input"
  >
    <i class="ddi ddi-search" />
    <input
      ref="inputRef"
      v-model="internalValue"
      :placeholder="placeholder"
      :class="{'small-text' : showSmallText}"
      class="sleek-filter-input__input"
      @focus="inputFocus=true"
      @blur="inputFocus=false"
    >
    <i v-if="internalValue" class="ddi ddi-close" @click="clearValue" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SleekFilterInput',

  props: {
    showSmallText: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Enter text...',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      inputFocus: false,
    }
  },

  computed: {
    internalValue: {
      get(): any {
        return this.modelValue
      },
      set(newValue: any) {
        this.$emit('update:modelValue', newValue)
      },
    },
  },

  methods: {
    clearValue() {
      this.internalValue = ''
    },
    focusInput() {
      // @ts-ignore
      this.$refs.inputRef.focus()
    },
  },
})
</script>
<style lang="scss">
.sleek-filter-input {
  display: flex;
  align-items: center;
  height: 30px;
  width: 320px;
  max-width: 100%;
  border-bottom: 1px solid $color--gray-30;

  @include media-breakpoint-down(md) {
    width: 100%;
  }

  &:hover,
  &:focus,
  &.focused {
    border-color: $color--gray-45;
  }

  &.full-width {
    width: 100%;
  }

  &__input {
    width: 100%;
    background: transparent;
    border: transparent;
    outline: none;
    @include lettering--p;

    &.small-text {
      @include lettering--p-sm;
    }

    &::-ms-clear {
      display: none;
    }
  }

  .ddi-search {
    margin-right: 4px;
    font-size: 16px;
    color: var(--color-text-third);
  }

  .ddi-close {
    margin-left: 4px;
    font-size: 12px;
    @include clickable-gray-color-states;
  }
}
</style>
